export default __webpack_public_path__ + "static/media/user.ca214ade.svg";